import React from 'react';

const OtpTrackingFormModal = React.lazy(() => import('../components/FormModal'));
const otpTrackingModalRegistry = {
    notification_otpTrackingId: OtpTrackingFormModal
};
export default otpTrackingModalRegistry;
